module.exports = __webpack_public_path__ + "assets/img/4e8c5d235290d90488bf575f041146b2.png";